module.exports = __webpack_public_path__ + "static/media/close-icon.4c0e4258.svg";